import { SaveDynamicAttributeGroup } from "@/modules/dynamic-attributes/feature/save-dynamic-attribute-group";
import { useEditorConfig } from "../model/config/use-config";
import { FormInModal } from "@/shared/form/form-in-modal";
import { useTranslations } from "use-intl";
import { AddButton } from "@/shared/form/button";

export function SaveGroup() {
  const { entity } = useEditorConfig();

  const t = useTranslations("AttributesPageWidget");

  return (
    <FormInModal
      title={t("Save group")}
      trigger={(open) => (
        <AddButton type="text" onClick={open}>
          {t("Save group")}
        </AddButton>
      )}
      form={(close) => (
        <SaveDynamicAttributeGroup entity={entity} afterSubmit={close} />
      )}
    />
  );
}
